// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "bdd3e89-dirty",
    "hash": "bdd3e89",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "bdd3e89-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
